import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexContainer, FlexItem } from '../../styled/layout.styled';
import { Caption } from '../../styled/typograpghy.styled';
import CopyClip from '../reusable/CopyClip/CopyClip';
import dateFormat from '../../utils/dateFormat';

const StyledFlexContainer = styled(FlexContainer)`
  width: 100%;
  border-radius: 4px;
  background-color: #22096c;
`;

const StyledH5 = styled.h5`
  color: #ffffff;
  margin: 0 0 8px 0;
`;

const DashboardBlog = ({ name, link, createdAt }) => (
  <>
    <StyledFlexContainer
      alignItems="center"
      mobilePadding="16px"
      mobileFlexDirection="column"
      padding="24px"
      justifyContent="space-between"
    >
      <FlexContainer flexDirection="column" mobileWidth="100%" mobileMargin="0 0 31px 0">
        <StyledH5>{name}</StyledH5>
        <Caption color="#c7baf1">{dateFormat(createdAt)}</Caption>
      </FlexContainer>
      <FlexItem width="65%" mobileWidth="100%">
        <CopyClip link={link} />
      </FlexItem>
    </StyledFlexContainer>
  </>
);

DashboardBlog.propTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
};

export default DashboardBlog;
